import { useMemo } from 'react';

import useStudentExamPendency from '@/data/hook/student-dashboard/useStudentExamPendency';
import { ROUTES } from '@/utils/routes';
import { StudentShortcutType } from '@/utils/student-dashboard/getStudentShortcuts';

export type StudentShortcut = {
  type: StudentShortcutType;
  href?: string;
  count?: number;
};

type UseStudentShortcutsParams = {
  studentId?: number;
  klassId?: number;
  slug?: string;
};

export default function useStudentShortcuts({
  studentId,
  klassId,
  slug,
}: UseStudentShortcutsParams) {
  const { examPendency, isLoading, error } = useStudentExamPendency({
    studentId,
    klassId,
  });

  const shortcuts = useMemo<StudentShortcut[]>(() => {
    const lessonsHref =
      slug && klassId ? ROUTES.COURSES.INFO(slug, klassId) : undefined;

    const shortcutByType: Record<StudentShortcutType, StudentShortcut> = {
      [StudentShortcutType.LESSONS]: {
        type: StudentShortcutType.LESSONS,
        href: lessonsHref,
      },
      [StudentShortcutType.SCHEDULE]: { type: StudentShortcutType.SCHEDULE },
      [StudentShortcutType.EXAMS]: {
        type: StudentShortcutType.EXAMS,
        count: examPendency.count,
      },
      [StudentShortcutType.PROJECTS]: {
        type: StudentShortcutType.PROJECTS,
        href: ROUTES.PROJECTS.BASE,
      },
      [StudentShortcutType.PERFORMANCE]: {
        type: StudentShortcutType.PERFORMANCE,
        href: ROUTES.SKILLS.BASE,
      },
    };

    return Object.values(shortcutByType);
  }, [slug, klassId, examPendency.count]);

  return { shortcuts, isLoading, error };
}
